import React from 'react';
import numeral from 'numeral';
import ReactTooltip from "react-tooltip";
import { normalizeCourierServices } from "../../../../../services/helpers/courier";
import { updateTestOrderWaybill } from '../../../../../store/action/order';
import { isAuthenticated } from '../../../../../store/action/auth';
import Status from '../../../helpers/status';

export default function (props) {
    const { user, token } = isAuthenticated();
    let {
        orderId,
        courierWaybillId,
        courierCompany,
        courierType,
        courierName,
        courierPhone,
        fulfillmentOrderId,
        fulfillmentServiceId,
        fulfillmentServiceCode,
        fulfillmentServiceName,
        fulfillmentStatus,
        orderType,
        status,
        tags,
        extra,
    } = props.data;

    let orderStatus = status;
    let airwaybill, courierDetails, extraView;
    let normalize = normalizeCourierServices(courierCompany, courierType);
    
    let companyType;

    let tagView;
    if (tags && tags.length > 0) {
        tagView = (
            <div className="mt-3 pointer order-empty-tags" onClick={() => props.onClickTag(orderId,'edit')}>
                <i className="fas fa-tag"></i> <text>Edit Tags</text>
                <div className="row pl-3">
                {
                    tags.map(i => (
                        <div className="badge badge-info px-2 py-1 mr-1">{i}</div>
                    ))
                }
                </div>
            </div>
        )
    } else {
        tagView = (
          <div className="mt-3 pointer order-empty-tags" onClick={() => props.onClickTag(orderId)}>
            <i className="fas fa-tag"></i> Tambah Tags
          </div>
        )
    }

    let fulfillmentView;
    if (user.integrations && user.integrations.filter(i => i.scopes.includes("write_fulfillment")).length > 0) {
      fulfillmentView = (
        <div>    
          <br/>            
          <small>FULFILLMENT</small>
          <div className="rounded p-2 mb-1 border shadow--hover">
            {
              fulfillmentOrderId ? 
              <small>
                <b>{fulfillmentServiceName} </b>
                <div className={`badge badge-info badge-pill`}>{fulfillmentStatus}</div> <br/>
              </small>
              :
              <small>
                BELUM DIKEMAS
              </small>
            }
          
          </div>
        </div>
      )
    }

    if (orderType === "pickupAppBulk") {
        let arr = courierCompany.split(",");
        if (arr.length > 1 ) {
            let normalizeArr = arr.reduce((r,i) => {
                r.push(normalizeCourierServices(i).companyName);
                return r
            },[])
            companyType = normalizeArr.toString()
        } else {
            companyType = normalize.companyName
        }

    } else {
        companyType = normalize.companyName + " - " + normalize.typeView;
    }

  if (courierWaybillId) {
    airwaybill = (
        <div>
          No Resi: <b>{courierWaybillId}</b>
        </div>
    )
  }

  if (courierName && courierPhone) {
    courierDetails = (
        <div>
          <strong>{courierName+" "} <u><a href={`http://api.whatsapp.com/send?phone=${courierPhone.substring(1)}`}>{courierPhone}</a></u></strong>
          <br/>
        </div>
    )
  } else {
    courierDetails = null
  }

  if (extra && extra.length > 0) {
    extraView = (
      <div className="mt-2">
         <small>EXTRA REQUEST</small>
         <div className="rounded p-2 mb-1 border shadow--hover">
         { extra.map((i,idx) => (
              <div key={idx} className="mb-1">
                  <small>{i.name.toUpperCase()} {i.fee ? <b>{`+ Rp. ${numeral(i.fee).format("0,0")}`}</b> : null}</small>
              </div>
          ))}
         </div>
      </div>
    ) 
  }

  const testAction = props.test === 'notActive' || Status.isStatusAtEndState(status) ? null : (
    <div className="mt-2 text-center">
          <span className="badge badge-warning">WEBHOOK</span>
          <div className="mb-2 pointer">
              <ReactTooltip/>
              <a onClick={async () => {
                const res = await updateTestOrderWaybill(orderId);
                if (!res.success) {
                  alert(`Failed update waybill`);
                  return
                }
                alert(`Berhasil update waybill`);
                window.location.reload();
              }}
                className="action-item mr-2"
                data-tip={'Update Waybill'}
                title={'Ganti resi kurir'}>
                  <i className="fas fa-file-alt"></i>
              </a><br/>
              <small>UPDATE WAYBILL</small>
          </div>
    </div>
  )

  if (status === 'confirmed') {
    return (
      <div>{companyType} <br/>
        { airwaybill }
        { extraView }
        { fulfillmentView }
        { tagView }
        { testAction }
      </div>
    )
  } else if (status === 'courierNotFound') {
    return (
      <div>
          {companyType}
          <br/>
        <div className="text-muted">driver tidak ditemukan</div>
        { extraView }
        { fulfillmentView }
        { tagView }
        { testAction }
      </div>
    )
  } else if (status === 'rejected') {
    return (
      <div>
          {companyType}
          <br/>
        <div className="text-muted">ditolak oleh driver</div>
        { extraView }
        { fulfillmentView }
        { tagView }
        { testAction }
      </div>
    )
  } else if (status === 'cancelled') {
    return (
      <div>
        {companyType}
        <br/>
        { extraView }
        { fulfillmentView }
        { tagView }
        { testAction }
      </div>
    )
  } else if (status === 'completed' ||
      orderStatus === 'delivered') {
    return (
      <div>
          {companyType}
          <br/>
        <strong>{courierName}</strong>
        <br/>
        { airwaybill }
        { extraView }
        { fulfillmentView }
        { tagView }
        { testAction }
      </div>
    )
  } else {
    return (
      <div>
          { companyType }
          { courierDetails }
          { airwaybill }
          { extraView }
          { fulfillmentView }
          { tagView }
          { testAction }
      </div>
    )
  }    
}